import { useCallback, useState } from 'react'
import { OtpTurnstileGate } from '../lib/otpTurnstile'

/**
 * One phone-send token gate per screen (see lib/otpTurnstile.ts; ported from
 * the consumer's components/useOtpTurnstile.ts). Spread `widget` onto the
 * screen's <Turnstile>, and send every /phone/start through
 * `sendWithTurnstile(gate, ...)`.
 */
export function useOtpTurnstile(configured: boolean) {
  const [refreshKey, setRefreshKey] = useState(0)
  const [gate] = useState(() => new OtpTurnstileGate({
    configured,
    remount: () => setRefreshKey((n) => n + 1),
  }))
  const onToken = useCallback((t: string) => gate.offer(t), [gate])
  const onInteractive = useCallback((on: boolean) => gate.setInteractive(on), [gate])
  const onRender = useCallback(() => gate.rendered(), [gate])
  const onError = useCallback(() => gate.failed(), [gate])
  return { gate, widget: { onToken, onInteractive, onRender, onError, refreshKey } }
}
